import { STATE_COLORS } from '../monitoringTheme';

/** Couleur d'étiquette d'un statut d'appel IA : toujours doublée du libellé. */
export const STATUS_COLOR: Record<string, string> = {
    ok: STATE_COLORS.good,
    failed_api: STATE_COLORS.critical,
    timeout: STATE_COLORS.critical,
    failed: STATE_COLORS.critical,
    cancelled: STATE_COLORS.neutral,
    abandoned: STATE_COLORS.warning,
    started: STATE_COLORS.warning,
};
